export const toDateInput = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getReportRange = (preset, now = new Date()) => {
  const end = new Date(now);
  const start = new Date(now);
  if (preset === "yesterday") {
    start.setDate(start.getDate() - 1);
    end.setDate(end.getDate() - 1);
  } else if (preset === "week") {
    start.setDate(start.getDate() - 6);
  } else if (preset === "month") {
    start.setDate(start.getDate() - 29);
  }
  return { start: toDateInput(start), end: toDateInput(end) };
};

export const billReportDate = (bill) => toDateInput(new Date(bill?.createdAt));

export const filterBillsByRange = (bills = [], start, end) => bills.filter((bill) => {
  if (!bill?.createdAt) return false;
  const date = billReportDate(bill);
  return date >= start && date <= end;
});

const amount = (value) => Number(value || 0);

export const aggregateBillTotals = (bills = []) => {
  const paid = bills.filter((bill) => String(bill.billStatus).toLowerCase() === "paid");
  const voidBills = bills.filter((bill) => String(bill.billStatus).toLowerCase() === "void");
  const collected = paid.reduce((sum, bill) => sum + amount(bill.settlementAmount ?? bill.grandTotal), 0);
  return {
    paidOrders: paid.length,
    voidOrders: voidBills.length,
    collected,
    averageOrderValue: paid.length ? collected / paid.length : 0,
    subtotal: paid.reduce((sum, bill) => sum + amount(bill.subTotal), 0),
    discount: paid.reduce((sum, bill) => sum + amount(bill.discountAmount), 0),
    tax: paid.reduce((sum, bill) => sum + amount(bill.cgstAmount) + amount(bill.sgstAmount), 0),
    serviceCharge: paid.reduce((sum, bill) => sum + amount(bill.serviceChargeAmount), 0),
    packaging: paid.reduce((sum, bill) => sum + amount(bill.packagingCharge), 0),
    voidValue: voidBills.reduce((sum, bill) => sum + amount(bill.settlementAmount ?? bill.grandTotal), 0),
  };
};

const escapeCsvCell = (value) => {
  const text = String(value ?? "");
  const spreadsheetSafeText = /^[=+\-@]/.test(text.trimStart()) ? `'${text}` : text;
  return `"${spreadsheetSafeText.replace(/"/g, '""')}"`;
};

export const createCsv = (headers, rows) => [headers, ...rows]
  .map((row) => row.map(escapeCsvCell).join(","))
  .join("\r\n");
